import { sendDelete, sendGet, sendPost, sendPut } from "../base";
import { getAPIData } from "../helpers";
import { Preset } from "./types";

type GetPresetsParams = {
  featureType: string;
};

export const getPresets = ({ featureType }: GetPresetsParams) =>
  getAPIData(
    sendGet("dropshipping/presets/", {
      feature_type: featureType,
    })
  );

type CreatePresetParams = {
  data: Omit<Preset, "created_at" | "id">;
};

export type UpdatePresetParams = {
  data: Partial<Omit<Preset, "created_at">>;
};

export const createPreset = ({ data }: CreatePresetParams) =>
  sendPost("dropshipping/presets/", { ...data });

export const updatePreset = ({ data }: UpdatePresetParams) =>
  sendPut(`dropshipping/presets/${data.id}`, { ...data });

export const deletePreset = (id: number) =>
  sendDelete(`dropshipping/presets/${id}`, {});
